export type LocaleDataUrl = string | ArrayBuffer | null;

function readAsDataUrl(_file: File): Promise<LocaleDataUrl> {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.addEventListener(
      "load",
      () => {
        resolve(fileReader.result);
      },
      false
    );
    fileReader.readAsDataURL(_file);
  });
}

export default readAsDataUrl;
